import { useEffect, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { fetchAuthMe } from './store/AuthmeSlice/authmeSlice';


  const IsManagerWrapper = ({children }) => {
    // const isManager = useSelector(selectUserIsManager);

    const dispatch = useDispatch();
 
    const { data, status, error } = useSelector((state) => state.authme);
  
    const token = useSelector(state => state.user.token)
  
    const [loading, setLoading] = useState(false);


  //////

 
  useEffect(() => {

    if(status === 'idle' && token){
      dispatch(fetchAuthMe())
      setLoading(true)
    }
    else if (status === 'loading') {
      setLoading(true);
    } else {
      setLoading(false);
    }
  
  }, [status]);

  if (loading) {
    return <div  
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',

         }}>
          <TailSpin
          visible={true}
          height="40"
          width="40"
           color="rgb(246,229,56)"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
          />
    </div>;
  }

  else if (error || !token ) {

    return <Navigate to="/login" />;
  }



  /////
    
  // A user is treated as a manager if the backend flags is_manager, OR if the
  // data itself shows they manage their department or factory (is_manager can be
  // false for a genuine department/factory head — see auth/me department.manager).
  else if (
    data?.is_manager ||
    data?.department?.manager?.job_id === data?.job_id ||
    data?.factory?.manager?.job_id === data?.job_id
  ) {

      return children;

    }
  
    else{

      // return <>not autherized</>;
      return <Navigate to="/not_authorized" />;
    }

  };
  
  export default IsManagerWrapper;